export const UPDATE_FLOW_DATA = 'UPDATE_FLOW_DATA';
export const UPDATE_FLOW = 'UPDATE_FLOW';
export const INIT_FLOW = 'INIT_FLOW';
export const RESET_FLOW = 'RESET_FLOW';
